<div class="ro">
  @if (state === "error") {
    <section class="bk-panel ro__error" role="alert">
      <p class="ro__error-title">The campaign report could not be loaded.</p>
      <p class="ro__error-body">Check your connection and try again.</p>
      <button type="button" class="bk-btn bk-btn--ghost" (click)="retry()">Try again</button>
    </section>
  } @else {
    <!-- Every send, with how it went -->
    <app-campaign-messages-report-table
      class="ro__wide"
      [messageData]="campaignReport.messagesReport"
      [loading]="state === 'loading'"
    ></app-campaign-messages-report-table>

    <!-- Delivery by message and by group -->
    <div class="ro__pair">
      @if (state === "loading") {
        <span class="bk-skel ro__chart-skel" aria-hidden="true"></span>
        <span class="bk-skel ro__chart-skel" aria-hidden="true"></span>
      } @else {
        <app-engagement-breakdown-by-messages-graph
          [graphData]="campaignReport.messagesGraphs?.campaignMessageBreakDownGraph ?? null"
        ></app-engagement-breakdown-by-messages-graph>
        <app-delivery-rate-by-recipients-graph
          [graphData]="campaignReport.recipientsGraphs?.deliveryRateByGroup ?? null"
        ></app-delivery-rate-by-recipients-graph>
      }
    </div>

    <!-- Who it reached -->
    <app-campaign-recipients-report-table
      class="ro__wide"
      [recipientData]="campaignReport.recipientsReport"
      [loading]="state === 'loading'"
    ></app-campaign-recipients-report-table>

    <div class="ro__pair">
      @if (state === "loading") {
        <span class="bk-skel ro__chart-skel" aria-hidden="true"></span>
        <span class="bk-skel ro__chart-skel" aria-hidden="true"></span>
      } @else {
        <app-gender-distribution-graph
          [graphData]="campaignReport.messagesGraphs?.GenderDistributionReport ?? null"
        ></app-gender-distribution-graph>
        <app-age-group-distribution-graph
          [graphData]="campaignReport.recipientsGraphs?.ageDistributionPieReport ?? null"
        ></app-age-group-distribution-graph>
      }
    </div>
  }
</div>
